export const debounce = (fn, delay) => {
  let timeoutId;
  return (...args) => {
    return new Promise(resolve => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        resolve(fn.apply(void 0, args));
      }, delay);
    });
  };
};